export const PLATFORM_NAME = "BharatCredits";
export const DEVELOP_BY = "Adciasis Solutions Pvt. Ltd.";

export const LOAN_TYPES = [
  { value: "goldSilverLoan", labelKey: "customer.add.loanTypes.goldSilverLoan", defaultInterest: 12 },
  { value: "personalLoan", labelKey: "customer.add.loanTypes.personalLoan", defaultInterest: 24 },
  { value: "propertyLoan", labelKey: "customer.add.loanTypes.propertyLoan", defaultInterest: 15 },
  { value: "vehicleLoan", labelKey: "customer.add.loanTypes.vehicleLoan", defaultInterest: 18 },
];

export const COLLATERAL_TYPES = [
  { value: "goldJewellery", labelKey: "customer.add.collateralTypes.goldJewellery" },
  { value: "silverJewellery", labelKey: "customer.add.collateralTypes.silverJewellery" },
  { value: "mobilePhone", labelKey: "customer.add.collateralTypes.mobilePhone" },
  { value: "motorbike", labelKey: "customer.add.collateralTypes.motorbike" },
  { value: "others", labelKey: "customer.add.collateralTypes.others" },
];
